<template>
    <Select
        ref="pSelector"
        v-model="selectedProductId"
        style="width: 200px; margin-left: 20px;"
        filterable
        clearable
        :filter-by-label="true"
        @on-change="handleProductChange"
    >
        <Option
            v-for="item in productList"
            :key="item.productUuid"
            :value="item.productUuid"
        >{{ getOptionLabel(item) }}</Option>
    </Select>
</template>

<script>
export default {
    name: "ProductSelector",
    props: {
        productList: {
            type: Array,
            default: () => []
        },
        productUuid: {
            type: String,
            default: ""
        }
    },
    computed: {
        selectedProductId: {
            get() {
                return this.productUuid || null;
            },
            set(value) {
                this.$emit("onProductChange", value);
            }
        }
    },
    methods: {
        getOptionLabel(item) {
            return `${item.seedFarmName} - ${item.productCode} - ${item.productName}`;
        },
        handleProductChange(id) {
            this.$emit("onProductChange", id);
        },
        clear() {
            this.$refs.pSelector.clearSingleSelect();
        }
    }
};
</script>